/**
 * Primary CTA destination — "Get My Fence Price".
 *
 * The main site flow now feeds the order configurator, where pricing is shown
 * live and contact details are captured progressively. The standalone
 * estimator still exists as a lead magnet (ads, campaigns, SEO) at
 * {@link ESTIMATOR_ANCHOR_HREF}; it is simply no longer the forced first step.
 */

export const ESTIMATOR_ID = "pricing-estimator";
export const ESTIMATOR_ANCHOR_HREF = `/#${ESTIMATOR_ID}`;

export const ORDER_CONFIGURATOR_ID = "configurator";
export const ORDER_CONFIGURATOR_HREF = `/order#${ORDER_CONFIGURATOR_ID}`;

/** Destination for the primary CTA site-wide. */
export const ESTIMATOR_HREF = ORDER_CONFIGURATOR_HREF;
export const PRIMARY_CTA_LABEL = "Get My Fence Price";
export const SECONDARY_CTA_LABEL = "Book Free Consultation";

/**
 * Click handler for a link pointing at {@link ESTIMATOR_HREF}. Prevents
 * navigation and smooth-scrolls when the configurator is already on the page.
 * Returns true when it handled the click in-page.
 */
export function scrollToEstimator(e?: { preventDefault: () => void }): boolean {
  if (typeof document === "undefined") return false;
  const el = document.getElementById(ORDER_CONFIGURATOR_ID);
  if (!el) return false;
  e?.preventDefault();
  el.scrollIntoView({ behavior: "smooth", block: "start" });
  return true;
}
